var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.sourceId
    ? _c(
        "div",
        { staticClass: "hkld-dropzone", attrs: { id: _vm.zoneId } },
        [
          _vm.dropzoneHeaders
            ? _c(
                "VueDropzone",
                {
                  key: _vm.dropzoneVueKey,
                  ref: "vueDropzone",
                  attrs: {
                    id: _vm.dropzoneId,
                    url: _vm.baseURL + "/" + (_vm.customUrl || "docs") + "/",
                    timeout: _vm.timeoutInMilli,
                    maxFileSizeInMB: _vm.docUploadSize,
                    maxNumberOfFiles: _vm.dropzoneMaxNumberOfFiles,
                    acceptedFileTypes: _vm.docUploadTypes,
                    headers: _vm.dropzoneHeaders,
                    autoProcessQueue: _vm.dropzoneAutoProcess,
                    previewTemplate: _vm.template,
                    language: _vm.DzLanguage,
                    hiddenInputContainer: _vm.hiddenInputContainer,
                  },
                  on: {
                    "vdropzone-files-added": _vm.filesAddedAction,
                    "vdropzone-sending": _vm.preSendRequest,
                    "vdropzone-success": _vm.uploadSuccess,
                    "vdropzone-error": _vm.setErrorMessage,
                    "vdropzone-queue-complete": _vm.queueComplete,
                  },
                },
                [
                  _vm._t("default", function () {
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "dz-default dz-message clearfix",
                          attrs: { id: "dropzone-content-" + _vm.sourceId },
                        },
                        [
                          _c("img", {
                            staticClass: "upload-img",
                            attrs: { src: "/cloud-upload.svg", alt: "Upload" },
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "upload-text inputContainer" },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("tender.attachment.uploadHint"))
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.uploadNoteRows.length
                            ? _c(
                                "div",
                                { staticClass: "hkld-dropzone__note" },
                                _vm._l(_vm.uploadNoteRows, function (noteRow) {
                                  return _c("div", { key: noteRow }, [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(noteRow) +
                                        "\n          "
                                    ),
                                  ])
                                }),
                                0
                              )
                            : _vm._e(),
                        ]
                      ),
                    ]
                  }),
                  _vm._v(" "),
                  _c("input", {
                    attrs: {
                      type: "hidden",
                      name: "token",
                      value: "file upload",
                    },
                  }),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.totalCount,
                  expression: "totalCount",
                },
              ],
              class: { "hkld-dropzone__uploading": _vm.totalCount > 0 },
              staticStyle: { color: "#0C3A58" },
            },
            [
              _c("span", [
                _vm._v(
                  _vm._s(_vm.totalCount) +
                    " " +
                    _vm._s(_vm.$t("tender.attachment.filesUploading"))
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.uploadResult,
                  expression: "uploadResult",
                },
              ],
              class: { "hkld-dropzone__upload-result": !!_vm.uploadResult },
              staticStyle: { color: "#0C3A58" },
            },
            [_c("span", [_vm._v(_vm._s(_vm.uploadResult))])]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.errorMessage,
                  expression: "errorMessage",
                },
              ],
              class: { "hkld-dropzone__error-message": !!_vm.errorMessage },
            },
            [_c("span", [_vm._v(_vm._s(_vm.errorMessage))])]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }